import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  LedgerIsLoading:false,
  error: "",
  reports: "",
  LedgerReports: "",
  DMTReports: "",
  ReceiveTopUp: "",
  WalletLoadReport: "",
  AepsTransactionReports: "",
  AepsPayoutReports: "",
  getAepsLedgerReports: "",
  scanAndPayReports: "",
  PayRentReports: "",
  RechargeReports: "",
};

//ledger Reports
const getLedgerReportsStart = (state) => {
  return {
    ...state,
    LedgerIsLoading: true,
    LedgerReports: "",
    error: "",
  };
};

const getLedgerReportsSuccess = (state, data) => {
  return {
    ...state,
    LedgerReports: data,
    LedgerIsLoading: false,
    error: "",
  };
};

const getLedgerReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    LedgerIsLoading: false,
  };
};

//DMT reports

const getDMTReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    DMTReports: "",
    error: "",
  };
};

const getDMTReportsSuccess = (state, data) => {
  return {
    ...state,
    DMTReports: data,
    isLoading: false,
    error: "",
  };
};

const getDMTReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//ReceiveTopUp reports

const getReceiveTopUpStart = (state) => {
  return {
    ...state,
    isLoading: true,
    ReceiveTopUp: "",
    error: "",
  };
};

const getReceiveTopUpSuccess = (state, data) => {
  return {
    ...state,
    ReceiveTopUp: data,
    isLoading: false,
    error: "",
  };
};

const getReceiveTopUpFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//WalletLoadReport reports

const getWalletLoadReportStart = (state) => {
  return {
    ...state,
    isLoading: true,
    WalletLoadReport: "",
    error: "",
  };
};

const getWalletLoadReportSuccess = (state, data) => {
  return {
    ...state,
    WalletLoadReport: data,
    isLoading: false,
    error: "",
  };
};

const getWalletLoadReportFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Aeps Transaction Reports

const getAepsTransactionReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    AepsTransactionReports: "",
    error: "",
  };
};

const getAepsTransactionReportsSuccess = (state, data) => {
  return {
    ...state,
    AepsTransactionReports: data,
    isLoading: false,
    error: "",
  };
};

const getAepsTransactionReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Aeps Payout Reports

const getAepsPayoutReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    AepsPayoutReports: "",
    error: "",
  };
};

const getAepsPayoutReportsSuccess = (state, data) => {
  return {
    ...state,
    AepsPayoutReports: data,
    isLoading: false,
    error: "",
  };
};

const getAepsPayoutReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Recharge Reports

const RechargeReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    RechargeReports: "",
    error: "",
  };
};

const RechargeReportsSuccess = (state, data) => {
  return {
    ...state,
    RechargeReports: data,
    isLoading: false,
    error: "",
  };
};

const RechargeReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//getAepsLedger Reports

const getAepsLedgerReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getAepsLedgerReports: "",
    error: "",
  };
};

const getAepsLedgerReportsSuccess = (state, data) => {
  return {
    ...state,
    getAepsLedgerReports: data,
    isLoading: false,
    error: "",
  };
};

const getAepsLedgerReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//scan And Pay Reports

const scanAndPayReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    scanAndPayReports: "",
    error: "",
  };
};

const scanAndPayReportsSuccess = (state, data) => {
  return {
    ...state,
    scanAndPayReports: data,
    isLoading: false,
    error: "",
  };
};

const scanAndPayReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Pay rent Reports

const PayRentReportsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    PayRentReports: "",
    error: "",
  };
};

const PayRentReportsSuccess = (state, data) => {
  return {
    ...state,
    PayRentReports: data,
    isLoading: false,
    error: "",
  };
};

const PayRentReportsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const resetLedgerReports = (state) => {
  return {
    ...state,
    error: "",
    isLoading: "",
    LedgerReports:""
  };
};


const reports = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LEDGER_REPORTS_START:
      return getLedgerReportsStart(state);
    case actionTypes.GET_LEDGER_REPORTS_SUCCESS:
      return getLedgerReportsSuccess(state, action.data);
    case actionTypes.GET_LEDGER_REPORTS_FAIL:
      return getLedgerReportsFail(state, action.err);

      case actionTypes.RESET_LEDGER_REPORTS_START:
        return resetLedgerReports(state);

    case actionTypes.GET_DMT_REPORTS_START:
      return getDMTReportsStart(state);
    case actionTypes.GET_DMT_REPORTS_SUCCESS:
      return getDMTReportsSuccess(state, action.data);
    case actionTypes.GET_DMT_REPORTS_FAIL:
      return getDMTReportsFail(state, action.err);

    case actionTypes.GET_RECEIVE_TOP_UP_REPORTS_START:
      return getReceiveTopUpStart(state);
    case actionTypes.GET_RECEIVE_TOP_UP_REPORTS_SUCCESS:
      return getReceiveTopUpSuccess(state, action.data);
    case actionTypes.GET_RECEIVE_TOP_UP_REPORTS_FAIL:
      return getReceiveTopUpFail(state, action.err);

    case actionTypes.GET_WALLET_LOAD_REPORTS_START:
      return getWalletLoadReportStart(state);
    case actionTypes.GET_WALLET_LOAD_REPORTS_SUCCESS:
      return getWalletLoadReportSuccess(state, action.data);
    case actionTypes.GET_WALLET_LOAD_REPORTS_FAIL:
      return getWalletLoadReportFail(state, action.err);

    case actionTypes.GET_AEPS_TRANSACT_REPORTS_START:
      return getAepsTransactionReportsStart(state);
    case actionTypes.GET_AEPS_TRANSACT_REPORTS_SUCCESS:
      return getAepsTransactionReportsSuccess(state, action.data);
    case actionTypes.GET_AEPS_TRANSACT_REPORTS_FAIL:
      return getAepsTransactionReportsFail(state, action.err);

    case actionTypes.GET_AEPS_PAYOUT_REPORTS_START:
      return getAepsPayoutReportsStart(state);
    case actionTypes.GET_AEPS_PAYOUT_REPORTS_SUCCESS:
      return getAepsPayoutReportsSuccess(state, action.data);
    case actionTypes.GET_AEPS_PAYOUT_REPORTS_FAIL:
      return getAepsPayoutReportsFail(state, action.err);

    case actionTypes.RECHARGE_REPORTS_START:
      return RechargeReportsStart(state);
    case actionTypes.RECHARGE_REPORTS_SUCCESS:
      return RechargeReportsSuccess(state, action.data);
    case actionTypes.RECHARGE_REPORTS_FAIL:
      return RechargeReportsFail(state, action.err);

    case actionTypes.GET_AEPS_LEDGER_REPORTS_START:
      return getAepsLedgerReportsStart(state);
    case actionTypes.GET_AEPS_LEDGER_REPORTS_SUCCESS:
      return getAepsLedgerReportsSuccess(state, action.data);
    case actionTypes.GET_AEPS_LEDGER_REPORTS_FAIL:
      return getAepsLedgerReportsFail(state, action.err);

    case actionTypes.SCAN_AND_PAY_REPORTS_START:
      return scanAndPayReportsStart(state);
    case actionTypes.SCAN_AND_PAY_REPORTS_SUCCESS:
      return scanAndPayReportsSuccess(state, action.data);
    case actionTypes.SCAN_AND_PAY_REPORTS_FAIL:
      return scanAndPayReportsFail(state, action.err);

    case actionTypes.PAY_RENT_REPORTS_START:
      return PayRentReportsStart(state);
    case actionTypes.PAY_RENT_REPORTS_SUCCESS:
      return PayRentReportsSuccess(state, action.data);
    case actionTypes.PAY_RENT_REPORTS_FAIL:
      return PayRentReportsFail(state, action.err);

    default:
      return state;
  }
};

export default reports;
